{
  "en": {
    "whats_new": {
      "category": {
        "news": "News",
        "product": "Product update",
        "tip": "Tip"
      },
      "category_plural": {
        "news": "News",
        "product": "Product updates",
        "tip": "Tips"
      },
      "earlier": "Earlier",
      "empty_description": "New features, tips and news from Ziggu will show up here.",
      "empty_title": "No posts yet",
      "helpful": "Helpful",
      "helpful_impersonation": "This is not possible while impersonating.",
      "helpful_mark": "Mark as helpful",
      "helpful_marked": "You found this helpful",
      "image_open": "Open image {index} of {count}",
      "load_failed_description": "Check your connection and try again.",
      "load_failed_title": "Couldn't load the posts",
      "new": "New",
      "no_matches_description": "No posts match your search or filters. Clear them to see everything.",
      "no_matches_title": "No matches",
      "read_more": "Read more",
      "retry": "Try again",
      "search": "Search posts…",
      "subtitle": "New features, tips and news from the Ziggu team.",
      "title": "What's new"
    }
  }
}
